/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_EmptyInputs */

const en_messages_empty = /** @type {(inputs: Messages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing scheduled yet.`)
};

const he_messages_empty = /** @type {(inputs: Messages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין הודעות מתוזמנות עדיין.`)
};

/**
* | output |
* | --- |
* | "Nothing scheduled yet." |
*
* @param {Messages_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_empty = /** @type {((inputs?: Messages_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_empty(inputs)
	return he_messages_empty(inputs)
});